import axios from 'axios';
import { BASE_URL, JWT_APP_ID } from '../../config/URL';
import platform from 'platform';

export const getPreviousLiveShowInfo = (id) => async (dispatch, getState) => {
  const state = getState();

  try {
    let url = `${BASE_URL}/catalog/v1.1/video/${id}?locale=en`;
    const res = await axios.get(url, {
      headers: {
        Authorization: state.auth.token,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
      },
    });

    let data = res.data.data;

    return data;
  } catch (err) {
    console.log(err?.message);
  }
};

export const getMediaInfo =
  (id, type, isPreload = false) =>
  async (dispatch, getState) => {
    const state = getState();

    try {
      let url =
        type === 'series'
          ? `${BASE_URL}/catalog/v1.0/playlist/${id}?locale=en`
          : `${BASE_URL}/catalog/v1.0/video/${id}?locale=en`;

      if (isPreload) {
        return axios.get(url, {
          headers: {
            Authorization: state.auth.token,
            'Cloudfront-JWT-AppId': JWT_APP_ID,
          },
        });
      }

      dispatch({
        type: 'GET_MEDIA_DETAIL',
      });

      const res = await axios.get(url, {
        headers: {
          Authorization: state.auth.token,
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      });

      let data = res.data.data;
      // if (type === 'series') {
      //   const result = await dispatch(getPlaylistItems(id))
      //   if (result && result.data) {
      //     const seasons = result.data
      //     data.items = seasons
      //   }

      //   data.items = data?.items || []
      // }

      dispatch({
        type: 'GET_MEDIA_DETAIL_SUCCESS',
        payload: data,
      });
      return data;
    } catch (err) {
      dispatch({
        type: 'GET_MEDIA_DETAIL_ERROR',
        err: err.response && err.response.data && err.response.data.error,
      });
    }
  };

export const getMediaAccess =
  (id, { sessionId, deviceId } = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const platformName = platform.name && platform.name.toLowerCase();
    const browserName = platformName.includes('safari') ? 'safari' : 'chrome';

    try {
      const res = await axios.get(
        `${BASE_URL}/catalog/v1.1/video/${id}/access?platform=${browserName}`,
        {
          headers: {
            Authorization: state.auth.token,
          },
          params: {
            ...(sessionId && { sessionId }),
            ...(deviceId && { deviceId }),
          },
        }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };

export const getPublicAccess =
  (id, { sessionId, deviceId } = {}) =>
  async (dispatch, getState) => {
    const platformName = platform.name && platform.name.toLowerCase();
    const browserName = platformName.includes('safari') ? 'safari' : 'chrome';

    try {
      const res = await axios.get(
        `${BASE_URL}/catalog/v1.1/video/${id}/publicAccess?platform=${browserName}`,
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID,
          },
          params: {
            ...(sessionId && { sessionId }),
            ...(deviceId && { deviceId }),
          },
        }
      );

      return res.data;
    } catch (err) {
      throw err;
    }
  };

export const clearMediaDetail = () => {
  return {
    type: 'CLEAR_MEDIA_DETAIL',
  };
};

export const getSingleMediaInfo = async (id) => {
  const res = await axios.get(
    `${BASE_URL}/catalog/v1.0/video/${id}?locale=en`,
    {
      headers: {
        'Cloudfront-JWT-AppId': JWT_APP_ID,
      },
    }
  );

  return res.data.data;
};
